/**
 * Created by pmnia on 12/03/15.
 */
(function () {
    'use strict';
    angular
        .module('blocks.storage')
        .factory('sessionServices', sessionServices);

    /*@ngInject*/
    function sessionServices(config, obtStorage, logger){
        var currentSession;
        return  {
            setSession:setSession,
            getSession: getSession,
            removeSession: removeSession,

            setArgs : setArgs,
            getArgs : getArgs
        };
        function setSession(data){
            if(data){
                data.language = data.language || config.language; //set a default language for every new session
                obtStorage.removeSession(data.cId);
                obtStorage.addSession(data);
                currentSession = data;
            }else{
                logger.warning('setSession function received an empty object');
            }
        }

        function getSession(cId){
            if(!angular.isUndefined(cId)
                && (!currentSession || currentSession.cId !== cId)){ //we search in the local storage
                currentSession = obtStorage.findSession(cId);
            }
            return currentSession; //is cid is empty or CID = the current session, elsse we search it inside the local storage
        }

        function removeSession(cId){
            if(!angular.isUndefined(cId)){
                obtStorage.removeSession(cId);
                if(currentSession && currentSession.cId === cId){
                    currentSession = null;
                }
            }else if(currentSession){ //remove the current sessoin
                obtStorage.removeSession(currentSession.cId);
                currentSession = null;
            }
        }

        function getArgs(arg){
            return arg && currentSession ? currentSession[arg] :null;
        }

        function setArgs(name, value, createSessionIfMissing) {
            if(! currentSession && createSessionIfMissing && name){
                currentSession = {};
            }
            if(currentSession && name){
                currentSession[name] = value;
                setSession(currentSession);
            }
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/storage/session.service.js
 ** module id = 97
 ** module chunks = 0
 **/